<template>
  <section :class="$style.container">
    <img :src="photoUrl" alt="" :style="{borderColor: groupColor}" />

    <div :class="$style.info">
      <p>{{activityTitle(activity)}}</p>
      <p v-if="info.includes('category') && activity.category">{{ activity.category.name }}</p>
      <p v-if="info.includes('stage') && activity.stage">{{ activity.stage.name }}</p>
      <div v-if="info.includes('rating') && activity.averageScore" :class="$style.rating">
        <FontAwesomeIcon
          v-for="n in 5"
          :key="n" :icon="faStar"
          :class="[$style.star, { [$style.full]: isFull(n, activity.averageScore) }]"
        />
      </div>
      <p><em v-if="inProgress" :class="$style.inProgress">in-progress</em> {{time}}</p>
    </div>

    <div v-if="actions.length > 0" :class="$style.actions">
      <SummarizeButton v-if="actions.includes('summarize')" :activity="activity" />
      <TakeNotesButton v-if="actions.includes('take-notes')" :activity="activity" />
      <AddKeyMomentButton v-if="actions.includes('add-key-moment')" :activity="activity" />
      <PlayButton v-if="actions.includes('play')" :activity="activity" />
    </div>
    <div v-else-if="isLink" :class="$style.actions">
      <FontAwesomeIcon :icon="faArrowCircleRight" />
    </div>
  </section>
</template>

<script>
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faArrowCircleRight } from '@fortawesome/pro-light-svg-icons/faArrowCircleRight'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'
import defaultAvatar from '@/assets/img/default-avatar.svg'
import activityHelpers from '@/helpers/activity'
import SummarizeButton from './SummarizeButton'
import TakeNotesButton from './TakeNotesButton'
import AddKeyMomentButton from './AddKeyMomentButton'
import PlayButton from './PlayButton'

export default {
  mixins: [
    activityHelpers
  ],
  components: {
    SummarizeButton,
    TakeNotesButton,
    AddKeyMomentButton,
    PlayButton,
    FontAwesomeIcon
  },
  props: {
    activity: {
      type: Object,
      required: true
    },
    info: {
      type: Array,
      validator (info) {
        return info.every(info => ['category', 'stage', 'rating'].includes(info))
      }
    },
    actions: {
      type: Array,
      validator (actions) {
        return actions.every(action => ['summarize', 'take-notes', 'add-key-moment', 'play'].includes(action))
      }
    },
    isLink: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      faArrowCircleRight,
      faStar
    }
  },
  computed: {
    inProgress () {
      return this.activity.status === 'in-progress'
    },
    photoUrl () {
      return this.activity.organizer.photoUrl
        ? this.activity.organizer.photoUrl
        : defaultAvatar
    },
    groupColor () {
      return this.activity.organizer.group && this.activity.organizer.group.color
    },
    time () {
      if (this.inProgress) {
        const formattedActualStartTime = moment.utc(this.activity.actualStartTime).local().format('HH:mm:ss')
        return `Started at ${formattedActualStartTime}`
      }

      const formattedActualEndTime = moment.utc(this.activity.actualEndTime).local().fromNow()
      return `Ended ${formattedActualEndTime}`
    }
  },
  methods: {
    isFull (n, score) {
      return n <= Math.round(score)
    }
  }
}
</script>

<style module lang="less" src="./CallInfo.less"></style>



// WEBPACK FOOTER //
// CallInfo.vue?f9295c5a